import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=cd47e0c2&scoped=true&"
import script from "./keyboard.vue?vue&type=script&lang=js&"
export * from "./keyboard.vue?vue&type=script&lang=js&"
import style0 from "./keyboard.vue?vue&type=style&index=0&id=cd47e0c2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd47e0c2",
  null
  
)

export default component.exports